/**
 * Толщина корпусных деталей — ЛДСП 16 мм (замечание Сергея № 17):
 * боковины, крышка, дно, стойки, полки, перегородки, цоколь и доборы,
 * а у стеллажей и комодов — все детали каркаса. Фасады — отдельно
 * (их толщину ещё уточняем), задняя стенка — своя.
 */
export const CARCASS_MM = 16;
export const HALF_CARCASS_MM = CARCASS_MM / 2;
